import { saveAs } from "file-saver";
import { fetchDetectionReportArchive } from "../apiClient/dataRetrievalRequest";

const archiveName = (contentDisposition, language) => {
  const match = /filename="?([^";]+)"?/i.exec(contentDisposition || "");
  if (match?.[1]) return match[1];
  const prefix = language?.startsWith("en") ? "report" : "informe";
  return `${prefix}_${new Date().toISOString().slice(0, 10)}.zip`;
};

export const downloadDashboardReport = async ({ filterConfig, filterValues, store, language = "es" }) => {
  const response = await fetchDetectionReportArchive({ filterConfig, filterValues }, store);
  saveAs(
    new Blob([response.data], { type: "application/zip" }),
    archiveName(response.headers?.["content-disposition"], language)
  );
};
